import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class CancelTradeRatingsUseCase extends UseCase {
  constructor({config, repository, tokenRequestValueObjectFactory}) {
    super()

    this._config = config
    this._repository = repository
    this._tokenRequestValueObjectFactory = tokenRequestValueObjectFactory
  }

  @inlineError
  async execute({token}) {
    const requestVO = this._tokenRequestValueObjectFactory({token})

    const [error, response] = await this._repository.cancelTrade({requestVO})

    return error ? Promise.reject(error) : response.toJSON()
  }
}
